import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/nocore.webp';
import screenshot_target from '../../../images/letterfunnel/robvandenhoogen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Rob van den Hoogen"
      firstname="Rob"
      companyname="Nocore"
      competition="CleanJack en Easyflex"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/robvandenhoogen.js